import IntroOutroChildView from './IntroOutroChildView';

export default IntroOutroChildView;
